import { Box } from '@mui/material';
import React from 'react';
import { makeStyles } from '@mui/styles';

import LogoSvg from 'assets/logo.svg';

const Logo = () => {
	const classes = useStyles();
	return <img src={LogoSvg} className={classes.logo} />;
};

const useStyles = makeStyles((theme) => ({
	logo: {
		width: 200
	}
}));

export default Logo;
